import { render, staticRenderFns } from "./apply_change_record.vue?vue&type=template&id=4a66ee81&scoped=true"
import script from "./apply_change_record.vue?vue&type=script&lang=js"
export * from "./apply_change_record.vue?vue&type=script&lang=js"
import style0 from "./apply_change_record.vue?vue&type=style&index=0&id=4a66ee81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a66ee81",
  null
  
)

export default component.exports